<template>
  <article>
    <div class="team-member__image-container">
      <BaseImage
        v-if="image"
        :id="image"
        class="team-member__image"
      />
      <a
        :href="`mailto:${email}`"
        class="team-member__email"
      >
        <EmailIcon class="team-member__email-icon"/>
        <span class="access-hidden">Email {{ name }}</span>
      </a>
    </div>
    <div
      class="team-member__name"
      v-text="name"
    />
    <div
      class="team-member__role"
      v-text="role"
    />
    <DisclosureContainer
      :id="slug"
      transition="TransitionSlide"
      class="team-member__bio-container"
      @toggle="expanded = !expanded"
    >
      <div
        class="team-member__bio"
        v-html="bio"
      />
    </DisclosureContainer>
    <DisclosureButton
      :controls="slug"
      class="team-member__toggle-bio"
    >
      <TextEpsilon
        class="team-member__toggle-copy"
        v-text="`${!expanded ? 'Read' : 'Close'} Bio`"
      />
      <DisclosureIndicator
        :expanded="expanded"
        class="team-member__button-indicator"
      />
    </DisclosureButton>
  </article>
</template>

<script>
  import EmailIcon from './EmailIcon';
  import TextEpsilon from './TextEpsilon';
  import DisclosureButton from './DisclosureButton';
  import DisclosureContainer from './DisclosureContainer';
  import DisclosureIndicator from './DisclosureIndicator';

  export default {
    components: {
      EmailIcon,
      TextEpsilon,
      DisclosureButton,
      DisclosureContainer,
      DisclosureIndicator,
    },
    props: {
      bio: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      role: {
        type: String,
        required: true,
      },
      email: {
        type: String,
        required: true,
      },
      image: {
        type: [Number, Boolean],
        required: true,
      },
      slug: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        expanded: false,
      };
    },
  };
</script>

<style
  scoped
  lang="scss"
>

</style>
